import _ from 'lodash';
import { CollidedItem } from './CollidedItem';
import { Move } from './Move';

export class Collision extends Move {
  rangeLabelY = 10;
  rangePointY = 10;
  distanceY = 1;
  rangeLabelX = 15;
  rangePointX = 10;
  distanceX = 2;
  minY = null;
  maxY = null;
  minX = null;
  maxX = null;
  box;

  constructor () {
    super();

    this.calculateColumnPosition = this.calculateColumnPosition.bind(this);
    this.calculateColumnsPosition = this.calculateColumnsPosition.bind(this);
    this.collisionAvoid = this.collisionAvoid.bind(this);
    this.isOverlappingX = this.isOverlappingX.bind(this);
    this.isOverlappingY = this.isOverlappingY.bind(this);
    this.isCrossingTop = this.isCrossingTop.bind(this);
    this.isCrossingBottom = this.isCrossingBottom.bind(this);
    this.isCrossingLeft = this.isCrossingLeft.bind(this);
    this.isCrossingRight = this.isCrossingRight.bind(this);
  }

  calculateColumnsPosition (columns) {
    // RESTORE POINTS TO ORIGINAL STATE BEFORE CALCULATION
    // _.each(columns, column => _.each(column.items, columnItem => columnItem.restore()));
    _.each(columns, (column, index) => this.calculateColumnPosition(column, index));
  }

  calculateColumnPosition (column, index) {
    let itemsSorted = _.orderBy(column.items, i => i.pointPosition.y);
    _.each(itemsSorted, (columnItem, index) => {
      const items = _.filter(itemsSorted, (i, k) => k !== index);

      const collidedItemDown = this.collisionAvoid(columnItem, columnItem.box, columnItem.pointBox, items, this.moveDownObject, this.isCrossingTop, this.isOverlappingY, this.rangeLabelY, this.rangePointY, 1, []);
      _.each(collidedItemDown.collidedWith, function (item) {
        item.isAsc = false;
      });

      const collidedItemUp = this.collisionAvoid(columnItem, columnItem.box, columnItem.pointBox, items, this.moveUpObject, this.isCrossingBottom, this.isOverlappingY, this.rangeLabelY, this.rangePointY, 1, []);
      _.each(collidedItemUp.collidedWith, function (item) {
        item.isAsc = true;
      });

      const distanceDown = Math.abs(collidedItemDown.box.y2 - columnItem.pointPosition.y);
      const distanceUp = Math.abs(collidedItemUp.box.y1 - columnItem.pointPosition.y);

      let collidedFinal = [];
      if (distanceUp < distanceDown) {
        collidedFinal = collidedItemUp;
      } else {
        collidedFinal = collidedItemDown;
      }

      if (this.isCrossingBottom(collidedItemDown.box)) {
        collidedFinal = collidedItemUp;
      }
      if (this.isCrossingTop(collidedItemUp.box)) {
        collidedFinal = collidedItemDown;
      }

      columnItem.addCollision(collidedFinal.collidedWith);
      collidedFinal.move();
    });

    const itemsCollided = _.filter(column.items, d => d.collidedWith.length);
    _.each(itemsCollided, (item) => {
      item.reorderLabels();
    });
  }

  setPositionsAligned (collidedItem) {
    return collidedItem;
  }

  collisionAvoid (columnItem, box, pointBox, items, moveFunction, compareFunction, overlappingFunction, rangeLabel, rangePoint, index, collided) {
    let collisionsText = _.filter(items, i => overlappingFunction(i.box, box, this.rangeLabelY));
    let collisionsPoint = _.filter(items, i => overlappingFunction(i.pointBox, box, this.rangePointY));

    const collisions = _.concat(collisionsText, collisionsPoint);

    if (collisionsText.length) {
      collided = collided.concat(_.differenceBy(collisionsText, collided, 'id'));
    }
    // if (index++ > 30) return box;

    if (collisions.length || compareFunction(box) || overlappingFunction(box, pointBox, rangePoint)) {
      return this.collisionAvoid(columnItem, moveFunction(box), pointBox, items, moveFunction, compareFunction, overlappingFunction, rangeLabel, rangePoint, ++index, collided);
    }

    const collidedItem = new CollidedItem(columnItem, box, collided);

    return collidedItem;
  }

  isOverlappingX (box1, box2, range) {
    const intersectX = (
      (box1.x1 >= box2.x1 && box1.x1 <= box2.x2) ||
      (box1.x2 >= box2.x1 && box1.x2 <= box2.x2) ||
      (box2.x1 >= box1.x1 && box2.x1 <= box1.x2) ||
      (box2.x2 >= box1.x1 && box2.x2 <= box1.x2));

    return intersectX && this.isOverlappingY(box1, box2, range);
  }

  isOverlappingY (box1, box2, range) {
    const box1CenterY = box1.y1 + ((box1.y1 - box1.y2) / 2);
    const box2CenterY = box2.y1 + ((box2.y1 - box2.y2) / 2);

    const distance = Math.abs(box1CenterY - box2CenterY);
    return distance <= range;
  }

  isCrossingTop (box) {
    return box.y1 <= this.minY + 5;
  }

  isCrossingBottom (box) {
    return box.y2 >= this.maxY - 0;
  }

  isCrossingLeft (box) {
    return box.x1 <= this.minX + 10;
  }

  isCrossingRight (box) {
    return box.x2 >= this.maxX - 5;
  }
}
